export const useIsCurrentRegion = (regionId?: MaybeRef<number>) => {
  const currentRegionId = useState("regionId", () => 0);
  return computed(() => currentRegionId.value === regionId);
};
